// extracted by mini-css-extract-plugin
module.exports = {"legalNotice":"footer-module--legal-notice--3Ic59","footerMain":"footer-module--footerMain--3BkvD"};